module.exports = __webpack_public_path__ + "img/discord.9be3369d.svg";